import React, { Component } from 'react';
import { connect } from "react-redux";

import axios from "axios";
import moment from "moment";
import { debounce } from "lodash";
import { setSidebar } from '../../Actions/endUserActions';

import Select from 'react-select';

import { checkCredentials } from '../../Helpers/checkCredentials.js';
import { Trans } from 'react-i18next';

//A React component will allow us to quickly iterate and change our code. It provides 
class EUMediaReminder extends Component {
    constructor(props) {
        super(props);

        this.submitReminder = debounce(this.submitReminder.bind(this), 500);
        this.updateField = this.updateField.bind(this);
        this.updateSelect = this.updateSelect.bind(this);

        this.state = {
            current_reminder: null,
            reminder_form: {'unit': 'weeks', 'number': 1}
        };
    }

    componentDidMount() {
        var self = this;

        axios.get('/ajax/media_reminders/' + this.props.match.params.book_id + '/create')
        .then(function(response) {
            self.setState({
                current_reminder: response?.data.reminder
            })
        })
        .catch(function(error) {
            if(error.response?.status == 401){
                showStatusMsg(error.response?.data.error);
            } else if(error.response?.status == 422) {
                var error_message = "";

                $.each(error.response?.data.errors, function (index, element) {
                    error_message += element + '<br />';
                });

                showStatusMsg(error_message);
            } else {
                showStatusMsg("Requested information not found");
            }

            if (self.props.closeModal) self.props.closeModal();
        })
    }

    submitReminder() {
        var self = this;

        if (this.state.reminder_form.number > 0) {
            axios.post('/ajax/media_reminders/' + this.props.match.params.book_id, this.state.reminder_form)
            .then(function(response) {
                axios.get('/ajax/eu-home/sidebar')
                .then(function(response) {
                    checkCredentials(response);
                    if (! ("status" in response?.data)) {
                        self.props.dispatch(setSidebar(response))
                    }
                })

                showStatusMsg(response?.data.message, 'success');
                if (self.props.closeModal) self.props.closeModal();
            })
            .catch(function(error) {
                if(error.response?.status == 401){
                    showStatusMsg(error.response?.data.error);
                } else if(error.response?.status == 422) {
                    var error_message = "";

                    $.each(error.response?.data.errors, function (index, element) {
                        error_message += element + '<br />';
                    });

                    showStatusMsg(error_message);
                } else {
                    showStatusMsg("Requested information not found");
                }
            })
        } else {
            showStatusMsg("The number for the reminder cannot be lower than 0", 'error')
        }
    }

    updateField(event) {
        var name = event.target.name
        var value = event.target.value

        var reminder_form = this.state.reminder_form
        reminder_form[name] = value

        this.setState({
            reminder_form: reminder_form
        })
    }

    updateSelect(option) {
        var name = option.name
        var value = option.value

        var reminder_form = this.state.reminder_form
        reminder_form[name] = value

        this.setState({
            reminder_form: reminder_form
        })
    }

    render() {
        return (
            <div className = "reveal card" id = "mediareminder-overlay" style={{display: "block",top:"0"}}> 
                <div className="p-16 border-bottom">
                    <span className="card-header-title"><Trans>Set Media Reminder</Trans></span>
                    <button className="close-button" data-close aria-label='Close modal' type='button' onClick={() => {
                        if (this.props.closeModal) this.props.closeModal();
                    }}>
                        <span aria-hidden='true'>&times;</span>
                    </button>
                    <div className = "clearfix"></div>
                </div>
                <div className="card-section">
                    <div className="form-container row collapse">
                        <div className="media-reminder-content margin-auto" style ={{width: "400px"}}>
                            {
                                this.state.current_reminder ? 
                                    <p className = "align-center mb-16 red-alert"><Trans>You already have a reminder set for</Trans> { moment(this.state.current_reminder, "YYYY-MM-DD").format("MMM DD, YYYY") }</p>
                                :
                                    null
                            }
                            <h4 className = "mb-24 align-center"><Trans>When will the media be completed?</Trans></h4>
                            <div className="media-reminder-select-group margin-auto" style = {{width: "180"}}>
                                <input type="number" defaultValue="1" min="0" name="number" style = {{width: "70px", float: "left"}} onChange={this.updateField}/>
                                <div className="media-reminder-space" style = {{width: "8px", height: "35px", float: "left"}}></div>
                                <Select 
                                    className="react_select_dropdown float-left margin-none media_reminder_unit"
                                    classNamePrefix="react_select"
                                    onChange={this.updateSelect}
                                    defaultValue={{value: "weeks", label: "Weeks", name: "unit"}}
                                    options={[{value: "days", label: "Days", name: "unit"}, {value: "weeks", label: "Weeks", name: "unit"}, {value: "months", label: "Months", name: "unit"}]}
                                />
                                <div className="clearfix"></div>
                            </div>
                            <div className = "caption black-lightest align-center"><Trans>We will send you a reminder at this time.</Trans></div>
                        </div>
                    </div>
                </div>

                <div className="card-button-section">
                    <a className="button primary float-right" onClick={this.submitReminder}><Trans>Save</Trans></a>
                    <a className="button float-right" onClick={() => {
                        if (this.props.closeModal) this.props.closeModal();
                    }}>
                        <Trans>Cancel</Trans>
                    </a>
                    <div className="clearfix"></div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession,
    endUser: store.endUser
});

export default connect(mapStateToProps)(EUMediaReminder);